import React, { useState } from 'react';
import './ButtonSidebar.css';
import axios from 'axios';
import starSVG from '../star.svg';
import cropSVG from '../Iconos/crop.svg';
import share2SVG from '../Iconos/share2.svg';
import arrowSVG from '../Iconos/arrow.svg';
import circleSVG from '../Iconos/clock-2.svg';
import xsvg from '../Iconos/x-circle.svg';
import { useTranslation } from 'react-i18next';
import {
    FacebookShareButton,
    TwitterShareButton,
    WhatsappShareButton,
    EmailShareButton,
    FacebookIcon,
    TwitterIcon,
    WhatsappIcon,
    EmailIcon,
} from 'react-share';

interface ButtonSidebarProps {
    selectedImage: string;
    onSaveDraft: (imageUrl: string) => void;
    onCropClick: () => void;
}

const ButtonSidebar: React.FC<ButtonSidebarProps> = ({ selectedImage, onSaveDraft, onCropClick }) => {
    const [hoveredButton, setHoveredButton] = useState<string | null>(null);
    const [showShareOptions, setShowShareOptions] = useState(false);
    const { t } = useTranslation();

    const handleMouseEnter = (buttonName: string) => {
        setHoveredButton(buttonName);
    };

    const handleMouseLeave = () => {
        setHoveredButton(null);
    };

    const handleShareClick = () => {
        setShowShareOptions(!showShareOptions);
    };

    const handleCloseShareOptions = () => {
        setShowShareOptions(false);
    };

    const handleSaveDraftClick = () => {
        onSaveDraft(selectedImage);
    };

    const handleDownloadClick = async () => {
        try {
            const backendUrl = process.env.REACT_APP_BACKEND_URL || 'http://localhost:3001'; // En desarrollo puedes usar localhost por defecto

            console.log(backendUrl);
            
            const response = await axios.post(`${backendUrl}/download-image`, { imageUrl: selectedImage }, {
                responseType: 'blob'
            });

            const url = window.URL.createObjectURL(new Blob([response.data]));
            const link = document.createElement('a');
            link.href = url;
            link.setAttribute('download', 'image.jpg'); // El nombre que quieras para la descarga
            document.body.appendChild(link);
            link.click();
            link.parentNode?.removeChild(link);
        } catch (error) {
            console.error('Error al descargar la imagen:', error);
        }
    };

    const shareUrl = selectedImage;
    const shareTitle = "Check out this image!";

    return (
        <div className='sidebar-2'>
            <div className='sidebar-questions'></div>
            <div className="sidebar-buttons">
                <button className="sidebar-button"
                    onMouseEnter={() => handleMouseEnter('recortar')}
                    onMouseLeave={handleMouseLeave}
                    onClick={onCropClick}>
                    <img src={cropSVG} alt="Recortar" />
                    {hoveredButton === 'recortar' && <span className="button-label">{t('Recortar')}</span>}
                </button>
                <button className="sidebar-button" onClick={handleSaveDraftClick}
                    onMouseEnter={() => handleMouseEnter('reloj')}
                    onMouseLeave={handleMouseLeave}>
                    <img src={circleSVG} alt="Borrador" />
                    {hoveredButton === 'reloj' && <span className="button-label">{t('Borrador')}</span>}
                </button>
                <button className="sidebar-button"
                    onClick={handleDownloadClick}
                    onMouseEnter={() => handleMouseEnter('arrow2')}
                    onMouseLeave={handleMouseLeave}>
                    <img src={arrowSVG} alt="Download" className='arrow' />
                    {hoveredButton === 'arrow2' && <span className="button-label">{t('Descargar')}</span>}
                </button>
                <button className="sidebar-button" onClick={handleShareClick}
                    onMouseEnter={() => handleMouseEnter('share')}
                    onMouseLeave={handleMouseLeave}>
                    <img src={share2SVG} alt="Compartir" />
                    {hoveredButton === 'share' && <span className="button-label">{t('Compartir')}</span>}
                </button>
            </div>

            {showShareOptions && (
                <div className="share-options">
                    <button className="sidebar-button" onClick={handleCloseShareOptions}>
                        <img src={xsvg} alt="Cerrar" />
                    </button>
                    <FacebookShareButton url={shareUrl} title={shareTitle}>
                        <FacebookIcon size={32} round />
                    </FacebookShareButton>
                    <TwitterShareButton url={shareUrl} title={shareTitle}>
                        <TwitterIcon size={32} round />
                    </TwitterShareButton>
                    <WhatsappShareButton url={shareUrl} title={shareTitle}>
                        <WhatsappIcon size={32} round />
                    </WhatsappShareButton>
                    <EmailShareButton url={shareUrl} subject={shareTitle} body="Check out this image!">
                        <EmailIcon size={32} round />
                    </EmailShareButton>
                </div>
            )}
        </div>
    );
};

export default ButtonSidebar;
